<template>
    <div class="hp-search overlay-foreground rounded-pill input-group">
        <div class="input-group-prepend">
            <button class="btn btn-sm mx-auto" type="button">
                <img src="images/icon-form-search-magnifier.svg">
            </button>
        </div>
        <div class="d-flex flex-grow-1">
            <input type="text" class="input align-self-center font-md text-gray-dk border-0" v-model="searchKey" v-focus="onfocus" @blur="clearSuggestions" @focus="showSuggestions" @keyup="showSuggestions" @click.stop="showSuggestions" @keyup.enter="search($event)" placeholder="Search deals..." />
        </div>
    </div>
</template>

<script>
    import searchMixin from './searchMixin'

    export default {
        mixins: [searchMixin],
        props: ["onfocus"],
        computed: {
            searchKey: {
                get() {
                    return this.$store.state.keyword
                },
                set(val) {
                    this.$store.commit('updateKeyword', val)
                }
            }
        },
    }
</script>
